import React from 'react';

import { useEffect } from 'react';

import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import { Container } from 'react-bootstrap';
import { Row } from 'react-bootstrap';
import { Col } from 'react-bootstrap';

import { FormGroup } from 'react-bootstrap';
import { FormLabel } from 'react-bootstrap';
import { FormControl } from 'react-bootstrap';
import { Button } from 'react-bootstrap';

import MediaUsageGoalStore from '../../../stores/MediaUsageGoalStore';

const MediaUsageGoalEditPage = ({ users }) => {
    const navigate = useNavigate();

    const store = MediaUsageGoalStore((state) => state);

    //useParams returns strings, so we convert it to a number here
    const mediaUsageGoalId = Number(useParams().mediaUsageGoalId);

    useEffect(() => {
        store.load(mediaUsageGoalId);
        // The [] is for specifying dependencies, and for componentDidMount lifecycle equivalent
        // we need to specify no dependencies.
        // See https://stackoverflow.com/questions/53945763/componentdidmount-equivalent-on-a-react-function-hooks-component
    }, []);

    if (null == store.mediaUsageGoal) {
        return <div>Loading ...</div>;
    }

    const getFormInputComponent = function (mediaUsageGoal, attributeName) {
        switch (attributeName) {
            case 'id':
                return (
                    <FormGroup
                        key={'form-' + attributeName}
                        controlId={attributeName}
                    >
                        <FormLabel>ID</FormLabel>
                        <FormControl
                            type="text"
                            readOnly
                            disabled
                            value={mediaUsageGoal.id}
                        />
                    </FormGroup>
                );

            case 'goal':
                return (
                    <FormGroup
                        key={'form-' + attributeName}
                        controlId={attributeName}
                    >
                        <FormLabel>
                            Label<span className="text-danger">*</span>
                        </FormLabel>

                        <FormControl
                            type="text"
                            value={mediaUsageGoal.goal}
                            onChange={(e) => {
                                store.updateAttribute('goal', e.target.value);
                            }}
                        />
                    </FormGroup>
                );

            default:
                return null;
        }
    };

    var formInputElements = [];

    formInputElements.push(getFormInputComponent(store.mediaUsageGoal, 'id'));
    formInputElements.push(getFormInputComponent(store.mediaUsageGoal, 'goal'));

    return (
        <Container style={{ marginTop: '10px', width: '100%' }}>
            <Row className="show-Container">
                <Col xs={12} md={8}>
                    <Button
                        onClick={() => {
                            navigate('/mediaUsageGoal/');
                        }}
                    >
                        Back to list
                    </Button>
                    <div>MediaUsageGoal Edit Page</div>
                    <br />
                    <form>
                        {formInputElements}

                        <br />
                        <br />

                        <Button
                            onClick={() => {
                                navigate('/mediaUsageGoal');
                            }}
                        >
                            Cancel
                        </Button>

                        <Button
                            style={{ marginLeft: '5px' }}
                            onClick={() => {
                                store.update(
                                    store.mediaUsageGoal,
                                    () => {
                                        alert('Your edits were saved');
                                        navigate('/mediaUsageGoal');
                                    },
                                    () => {
                                        alert('Something went wrong!');
                                    },
                                );
                            }}
                        >
                            Save
                        </Button>

                        <Button
                            style={{ marginLeft: '5px' }}
                            onClick={() => {
                                store.delete(
                                    store.mediaUsageGoal.id,
                                    () => {
                                        alert('The mediaUsageGoal was deleted');
                                        navigate('/mediaUsageGoal');
                                    },
                                    () => {
                                        alert('Something went wrong!');
                                    },
                                );
                            }}
                        >
                            Delete
                        </Button>
                    </form>
                </Col>
            </Row>
        </Container>
    );
};

export default MediaUsageGoalEditPage;
